import { dataProvider } from "@/@core/http";

/**
 * Checks if email is valid for front end validation
 * @function validateEmail
 * @param {String} email - Email to check
 */
export function validateEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
}

/**
 * Checks if email exists in the database
 * @function checkIfUserExists
 * @param {String} email - Email to check
 */
export async function checkIfUserExists(email) {
  return await dataProvider.customHttpCall("GET", `users/${email}/exists`);
}
